import axios from "axios";
import { authHeader } from "@/helpers/API/Auth/auth.header.js";
const API_URL = process.env.VUE_APP_ROOT_API;

class DepartmentService {
  //  DEPARTMENT RELATED APIs

  // Get department list
  async getDepartmentList(filter = "") {
    return await axios
      .get(API_URL + "crm/department" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get department data details
  async getDepartmentDetail(department_id, filter = "") {
    return await axios
      .get(API_URL + "crm/department/" + department_id + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add New department
  async addDepartment(data) {
    return await axios
      .post(API_URL + "crm/department", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Update department details
  async updateDepartment(department_id, data) {
    return await axios
      .patch(API_URL + "crm/department/" + department_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Delete department
  async deleteDepartment(department_id) {
    return await axios
      .delete(API_URL + "crm/department/" + department_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new DepartmentService();
